import { ConnectedPageLayout } from 'components/layout/page-layout';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Success from './Success';

const Profile = () => {
  const { t } = useTranslation('talent');

  return (
    <ConnectedPageLayout
      headerProps={{ accountProps: {} }}
      documentTitle={t('subscription.documentTitle')}
      drawerProps={{}}
    >
      <Success />
    </ConnectedPageLayout>
  );
};

export default Profile;
